class PolicyAmendmentPetitions {
    constructor(
        id,
        type,
        cancellationForm,
        paymentMethodForm,
        policyChangesForm,
        status,
        petitionNumber,
        createdAt,
        notes,
        createdBy,
    ) {
        this.id = id
        this.type = type
        this.cancellationForm = cancellationForm
        this.paymentMethodForm = paymentMethodForm
        this.policyChangesForm = policyChangesForm
        this.status = status
        this.petitionNumber = petitionNumber
        this.createdAt = createdAt
        this.notes = notes
        this.createdBy = createdBy
    }

    static fromJson({
        id,
        type,
        cancellationForm,
        paymentMethodForm,
        policyChangesForm,
        status,
        petitionNumber,
        createdAt,
        notes,
        createdBy,
    }) {
        return new PolicyAmendmentPetitions(
            id,
            type,
            cancellationForm,
            paymentMethodForm,
            policyChangesForm,
            status,
            petitionNumber,
            createdAt,
            notes,
            createdBy
        )
    }
}

export default PolicyAmendmentPetitions
